module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_vm._v("101 Things to do with Ramen Noodles")]), _c('div', {
    staticClass: "toc"
  }, [_c('p', [_c('b', [_vm._v("Table of Contents")])]), _c('dl', [_c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Helpful Hints")])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Soups")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tomato Noodle Soup")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Minestrone")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Egg Drop Soup")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e144",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beefed-Up Noodles")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e165",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken Consomme and Noodles")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e186",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Creamy Mushroom Soup")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e201",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Creamy Chicken Noodle Soup")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e218",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vegetable Beef Noodle Soup")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e235",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summer Garden Soup")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e262",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Southwest Vegetable Soup")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e289",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Asian Beef-Noodle Soup")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Salads")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e318",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spring Salad")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e347",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summer Picnic Salad")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e360",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Zucchini Salad")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e383",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Taco Salad")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e402",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three-Bean Salad")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e419",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Antipasto Salad")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e434",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pasta Salad")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e453",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oriental Chicken Salad")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e484",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fruity Ramen Salad")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e524",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Water Chestnut Ramen Salad")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e545",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweet-and-Sour Salad")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beef")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e578",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beef Ramenoff")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e603",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cheeseburger Ramen")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e618",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Creamy Beef and Broccoli Noodles")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e641",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beef Provencale")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e668",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marinated Beef")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e689",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cheddar Beef Casserole")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e718",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beef and Broccoli Stir-Fry")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e739",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beefy Mushroom Noodles")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e762",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beef Sukiyaki")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e793",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vegetable Beef Noodles")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e808",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beef ’n’ Potato Noodles")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e823",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beefy Chili Noodles")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e844",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ramen Burgers")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e859",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spicy Beef Noodles")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e878",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spicy Meat Loaf Cheese Roll")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e893",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Country Vegetable Beef")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e912",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beefy Noodles With Gravy")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e931",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Creamy Chicken and Broccoli")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e948",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spicy Chicken")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e965",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cheesy Chicken Divan")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e994",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken Lo Mein ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken Hollandaise")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1034",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken Veloute")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1055",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken Curry")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1076",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken Diablo")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Creamy Chicken Noodles")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken with Mushrooms ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1133",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken Allemande")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1162",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken Alfredo")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1187",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ramen Fajitas")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1206",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Italian Chicken")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1219",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fiesta Chicken")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1242",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cheesy Chicken Casserole")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1265",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken ’n’ Asparagus")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1282",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chinese-Style Ramen")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1305",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken Milano")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pork")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e1332",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("All-American Ramen")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e1347",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ham Omelets")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e1368",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pork Chop Ramen")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e1387",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cheesy Bacon Noodles")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e1400",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brats ’n’ Noodles")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e1409",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pork and Peppers")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e1440",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hungarian Skillet Meal")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e1459",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lean Pork Steak")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e1474",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tropical Ramen ")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seafood")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e1495",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cheesy Tuna Ramen")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e1512",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shrimp Ramen")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e1525",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cheesy Salmon Noodles")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e1542",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tuna Noodle Casserole")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e1563",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Creamy Mushroom Shrimp Ramen")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e1576",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twice-Baked Tuna Casserole")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e1593",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Garlic Shrimp ’n’ Veggies")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Family Favorites")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e1618",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Meaty Spaghetti")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e1633",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cheesy Noodles")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e1646",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ramen Nachos")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e1665",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Garlic Noodle Saute")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e1682",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Creamy Alfredo Noodles")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e1703",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mexican Casserole")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e1726",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pizza Pasta")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e1749",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lasagna")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e1768",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Primavera Pasta")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e1791",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Onion Noodles")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e1806",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Parmesan Noodles")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e1817",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cheesy Ranch Ramen")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e1828",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Buttery Chive Noodles ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e1841",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ramen Trail Mix")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e1860",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ramen Haystacks")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e1873",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Chinos")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e1890",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peach Treats")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e1909",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Maple and Brown Sugar Ramenmeal")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vegetable Entrees")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e1928",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Broccoli-Cauliflower Ramen")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e1947",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cheesy Vegetable Ramen")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e1962",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hollandaise Vegetables")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e1979",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Veggie Saute")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e2000",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chinese Fried Noodles")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e2017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tomato Saute")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e2032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Garlic Cilantro Noodles")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e2045",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chinese Veggie Noodles")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e2060",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Corny Cheese Noodles")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Metric Conversion Chart")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2835850b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bk01-toc.vue
// module id = 63
// module chunks = 0